import * as phoneNumberUtilJs from "libphonenumber-js/max";

// Copied from https://github.com/bolteu/bolt-nodejs-common/blob/develop/src/phoneNumber/PhoneNumber.ts

export default class PhoneNumberValidator {
    public static parse(phone: string): phoneNumberUtilJs.PhoneNumber | null {
        if (!phone) {
            return null;
        }
        try {
            return phoneNumberUtilJs.parsePhoneNumberFromString(phone) ?? null;
        } catch {
            return null;
        }
    }

    public static clean(input: string): string {
        let phone = input;
        if (!phone || phone === "+") {
            return "";
        }

        if (String(phone).trim().substr(0, 1) !== "+") {
            phone = `+${phone}`;
        }

        let phonePart = String(phone).trim().substr(1).trim();
        phonePart = phonePart.split("+").join("");
        phonePart = phonePart.split(" ").join("");
        phonePart = phonePart.split("(").join("");
        phonePart = phonePart.split(")").join("");
        phonePart = phonePart.split("/").join("");
        phonePart = phonePart.split("\\").join("");
        phonePart = phonePart.split(".").join("");
        phonePart = phonePart.split("-").join("");
        if (Number.isNaN(Number(phonePart))) {
            return "";
        }

        return (phonePart ? "+" : "") + phonePart;
    }

    public static isPossiblyValidPhoneNumber(phoneNumber: string): boolean {
        const parsedPhoneNumber = this.parse(this.clean(phoneNumber));

        if (!parsedPhoneNumber) {
            return false;
        }

        return parsedPhoneNumber.isPossible();
    }
}
